import React from "react";
import { format } from "date-fns";
import CalendarIcon from "../../icons/calendarIcon";
import EditIcon from "../../icons/editIcon";
import TrashIcon from "../../icons/trashIcon";
import { useAuth } from "../../hooks/useAuth";
import styles from "./style.module.css";

const TruckDayCard = ({ item, handleEdit, handelDelete }) => {
  const { auth } = useAuth();

  let monitorBy =
    auth?.monitorBy?.charAt(0).toUpperCase() + auth?.monitorBy?.slice(1);

  if (monitorBy === 'Days') {
    monitorBy = 'Track Days';
  } else if (monitorBy === 'Sessions') {
    monitorBy = 'Sessions';
  } else if (monitorBy === 'Laps') {
    monitorBy = 'Miles';
  }
  return (
    <div className={styles.truck_day_card}>
      <div className={styles.truck_day_card_head}>
        <div className={styles.truck_day_card_info}>
          <div className={styles.truck_day_card_info_date}>
            <div className={styles.truck_day_card_info_date_item}>
              <CalendarIcon />
              <span>{format(new Date(item.date.replace('Z', '')), "dd MMM yyyy")}</span>
            </div>
          </div>
          <div className={styles.truck_day_card_name}>{item.name}</div>
        </div>
        <div className={styles.truck_day_card_action}>
          <button type="button" onClick={() => handleEdit(item)}>
            <EditIcon />
          </button>
          <button type="button" onClick={() => handelDelete(item)}>
            <TrashIcon />
          </button>
        </div>
      </div>
      <div className={styles.truck_day_card_foot}>
        <div className={styles.truck_day_card_foot_desc}>
          # of {monitorBy}: {item.count}
        </div>
      </div>
    </div>
  );
};

export default TruckDayCard;
